/* ============================================================
   ATHLO+ — Creator dashboard (ADDON, in-locker)
   An affiliate/creator's OWN analytics, shown inside the locker and
   ONLY to a logged-in member the admins have linked to an affiliate
   row (affiliates.member_id). Everyone else — guests, ordinary
   members — gets {affiliate:false} and this file renders nothing.

   Identity is the SAME one the rest of the locker uses (hub-loyalty.js):
   App Proxy signature when a proxy is set (preferred — no token ever
   sent), else the locker token in headers. Never trusts the URL.

   Mount:   #lk-creator in sections/hub-locker.liquid (ships hidden)
   Backend: functions/v1/loyalty?action=affiliate-me  (rich payload:
            stats, metrics, series, source_split, vendors, benchmark,
            leaderboard, conversions, payouts, config)
   CSS:     assets/hub-locker-affiliate.css
   Removable: delete this file, the CSS, the two tags and the mount.
   ============================================================ */
(function () {
  'use strict';

  var B = document.body;
  var MOUNT = document.getElementById('lk-creator');
  if (!MOUNT) return;

  var EP = (B.getAttribute('data-loyalty-endpoint') || '').trim();
  var PROXY = (B.getAttribute('data-loyalty-proxy') || '').trim();
  var MEMBER = (B.getAttribute('data-member-id') || '').trim();
  var USE_PROXY = !!PROXY;
  var BASE = USE_PROXY ? PROXY : EP;
  if (!BASE || !MEMBER) return;

  var REDUCE = false;
  try { REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  function lockerToken() {
    try {
      var s = window.HubSession;
      return ((s && typeof s.token === 'function' && s.token()) ||
              (B.getAttribute('data-locker-token') || '')).trim();
    } catch (e) { return ''; }
  }
  function authHeaders() {
    var h = {};
    if (!USE_PROXY) { h['x-athlo-member'] = MEMBER; h['x-athlo-token'] = lockerToken(); }
    return h;
  }

  /* ---- helpers ---- */
  function el(tag, cls, html) { var n = document.createElement(tag); if (cls) n.className = cls; if (html != null) n.innerHTML = html; return n; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) { var n = (Number(cents) || 0) / 100; try { return n.toLocaleString(undefined, { style: 'currency', currency: 'SGD', currencyDisplay: 'narrowSymbol' }); } catch (e) { return '$' + n.toFixed(2); } }
  function money0(cents) { var n = Math.round((Number(cents) || 0) / 100); try { return '$' + n.toLocaleString(); } catch (e) { return '$' + n; } }
  function num(n) { try { return (Number(n) || 0).toLocaleString(); } catch (e) { return String(Number(n) || 0); } }
  function bpsPct(bps, dp) { var v = (Number(bps) || 0) / 100; if (dp === 0 || v === Math.round(v)) return Math.round(v) + '%'; return v.toFixed(1) + '%'; }
  function dateShort(iso) { if (!iso) return ''; try { return new Date(iso).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' }); } catch (e) { return String(iso).slice(0, 10); } }
  function monthLabel(k) { var m = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']; var p = String(k || '').split('-'); var i = (parseInt(p[1], 10) || 1) - 1; return m[i] || ''; }
  var BUCKET = { held: 'Booked', payable: 'Payable', paid: 'Paid', reversed: 'Reversed', flagged: 'Flagged' };

  /* ---- fetch + gate ---- */
  if (!USE_PROXY && !lockerToken()) {
    try { console.error('[hub-creator] no locker token in direct mode — creator dashboard will not load.'); } catch (e) {}
  }
  fetch(BASE + '?action=affiliate-me', { headers: authHeaders() })
    .then(function (r) {
      if (r.status === 401 || r.status === 403) { try { console.error('[hub-creator] refused (' + r.status + ') — creator dashboard will not load.'); } catch (e) {} }
      return r.json();
    })
    .then(function (d) {
      if (!d || !d.ok || !d.affiliate) return;
      try { render(d); } catch (e) { try { console.error('[hub-creator] render failed', e); } catch (x) {} return; }
      MOUNT.hidden = false;
      reveal();
      try { window.dispatchEvent(new CustomEvent('athlo:creator', { detail: d })); } catch (e) {}
    })
    .catch(function () {});

  /* ---- reveal + count-up ---- */
  function reveal() {
    var els = [].slice.call(MOUNT.querySelectorAll('[data-rev]'));
    els.forEach(function (n, i) {
      if (REDUCE) { n.style.opacity = 1; n.style.transform = 'none'; return; }
      setTimeout(function () { n.style.transition = 'opacity .5s ease, transform .5s cubic-bezier(.16,1,.3,1)'; n.style.opacity = 1; n.style.transform = 'none'; }, 60 + i * 55);
    });
    // hero count-up
    MOUNT.querySelectorAll('[data-count]').forEach(function (n) { setTimeout(function () { countUp(n); }, 220); });
    // chart bars
    var bars = MOUNT.querySelectorAll('.lkc__bar');
    setTimeout(function () { [].forEach.call(bars, function (b, i) { var f = b.querySelector('.lkc__fill'); var h = b.getAttribute('data-h'); if (REDUCE) { f.style.height = h + '%'; return; } setTimeout(function () { f.style.height = h + '%'; }, i * 70); }); }, 300);
    // open the first FAQ answer — measured HERE (mount now visible), never while hidden (scrollHeight 0)
    var first = MOUNT.querySelector('.lkc__qa.open .lkc__a');
    if (first) first.style.maxHeight = first.scrollHeight + 'px';
  }
  function countUp(n) {
    var target = parseFloat(n.getAttribute('data-count')) || 0;
    var kind = n.getAttribute('data-fmt') || 'money';
    function put(v) { n.textContent = kind === 'money' ? money(v) : num(v); }
    if (REDUCE) { put(target); return; }
    var dur = 950, start = performance.now();
    (function tick(now) { var p = Math.min(1, (now - start) / dur), e = 1 - Math.pow(1 - p, 3); put(target * e); if (p < 1) requestAnimationFrame(tick); else put(target); })(performance.now());
  }

  /* ---- render ---- */
  function render(d) {
    var p = d.profile || {}, s = d.stats || {}, mt = d.metrics || {}, cfg = d.config || {};
    var hold = cfg.hold_days != null ? cfg.hold_days : 30;
    var min = cfg.min_payout_cents || 0;
    var origin = (location.origin || 'https://athlo.sg');
    var refLink = origin + '/?ref=' + encodeURIComponent(p.handle || '');
    MOUNT.innerHTML = '';
    var wrap = el('div', 'lkc');
    MOUNT.appendChild(wrap);

    /* header */
    var top = el('div', 'lkc__top');
    top.appendChild(el('div', 'lkc__brand', '<span class="lkc__dot"></span><span class="lkc__eyebrow">Creator program</span>'));
    var codeChip = el('span', 'lkc__code', '<b>' + esc(p.code || '—') + '</b>');
    codeChip.appendChild(copyBtn(p.code || '', 'lkc__mini', 'Copy code'));
    top.appendChild(codeChip);
    wrap.appendChild(top);

    /* hero */
    var payable = s.payable_cents || 0;
    var ready = payable >= min;
    var hero = el('div', 'lkc__hero'); hero.setAttribute('data-rev', '1');
    var hl = el('div', 'lkc__hero-l');
    hl.appendChild(el('span', 'lkc__eyebrow', 'Payable now'));
    var heroN = el('div', 'lkc__hero-n dsp', money(0)); heroN.setAttribute('data-count', String(payable)); heroN.setAttribute('data-fmt', 'money');
    hl.appendChild(heroN);
    if (ready) {
      var rr = el('div', 'lkc__ready', '<span class="lkc__pill"><i class="lkc__i-check"></i> Ready</span> ' +
        (min ? 'Clears the ' + money0(min) + ' minimum · ' : 'Ready · ') + 'paid as ' + esc(p.payout_method === 'credit' ? 'store credit' : 'cash'));
      hl.appendChild(rr);
    } else {
      var pctToMin = min > 0 ? Math.min(100, Math.round((payable / min) * 100)) : 100;
      var meter = el('div', 'lkc__meter');
      meter.appendChild(el('div', 'lkc__meter-bar', '<span style="width:' + pctToMin + '%"></span>'));
      meter.appendChild(el('p', 'lkc__meter-l', money(payable) + ' of ' + money0(min) + ' — ' + money(min - payable) + ' to your next payout'));
      hl.appendChild(meter);
    }
    hero.appendChild(hl);

    /* hero right: lifetime / this month / rank */
    var hr = el('div', 'lkc__figs');
    hr.appendChild(fig(money(mt.lifetime_earned_cents), 'Lifetime earned'));
    var delta = deltaChip(mt.this_month_cents || 0, mt.last_month_cents || 0);
    hr.appendChild(fig(money(mt.this_month_cents), 'This month', delta));
    var lb = d.leaderboard || {};
    if (lb.rank && lb.of > 1) hr.appendChild(fig('#' + lb.rank, 'of ' + lb.of + ' this month'));
    hero.appendChild(hr);
    wrap.appendChild(hero);

    /* performance grid */
    var perf = el('div', 'lkc__perf'); perf.setAttribute('data-rev', '1');
    perf.appendChild(cell(num(mt.clicks), 'Clicks'));
    perf.appendChild(cell(num(mt.orders), 'Orders'));
    perf.appendChild(cell(mt.clicks > 0 ? bpsPct(mt.conversion_bps, 1) : '—', 'Conversion', 'orders ÷ clicks'));
    perf.appendChild(cell(mt.clicks > 0 ? money(mt.epc_cents) : '—', 'Per click', 'earnings ÷ clicks'));
    perf.appendChild(cell(money(s.booked_cents), 'Booked · maturing', null, 'warn'));
    perf.appendChild(cell(money0(s.paid_cents), 'Paid · lifetime'));
    perf.appendChild(cell(money0(mt.aov_cents), 'Avg order'));
    perf.appendChild(cell(bpsPct(mt.refund_bps, 1), 'Refund rate'));
    wrap.appendChild(perf);

    /* earnings chart */
    var series = d.series || [];
    var maxC = 0; series.forEach(function (x) { if (x.commission_cents > maxC) maxC = x.commission_cents; });
    wrap.appendChild(sect('Earnings', 'last 6 months'));
    if (maxC <= 0) {
      wrap.appendChild(rev(el('p', 'lkc__empty', 'Your monthly earnings will chart here as sales come in.')));
    } else {
      var chart = el('div', 'lkc__chart'); chart.setAttribute('data-rev', '1');
      series.forEach(function (x, i) {
        var h = Math.max(x.commission_cents > 0 ? 8 : 0, Math.round((x.commission_cents / maxC) * 100));
        var isCur = i === series.length - 1;
        var bar = el('div', 'lkc__bar' + (isCur ? ' is-cur' : '')); bar.setAttribute('data-h', h);
        bar.appendChild(el('div', 'lkc__fill', '<span class="lkc__barv">' + money0(x.commission_cents) + '</span>'));
        bar.appendChild(el('span', 'lkc__barm', monthLabel(x.month)));
        chart.appendChild(bar);
      });
      wrap.appendChild(chart);
    }

    /* funnel + attribution */
    wrap.appendChild(sect('Where it comes from'));
    var two = el('div', 'lkc__two'); two.setAttribute('data-rev', '1');
    // funnel
    var bench = d.benchmark || {};
    var funNote = '';
    if (mt.clicks > 0) {
      funNote = 'You convert <b>' + bpsPct(mt.conversion_bps, 1) + '</b> of clicks';
      if (bench.program_conversion_bps > 0) {
        funNote += mt.conversion_bps >= bench.program_conversion_bps
          ? ' — above the ' + bpsPct(bench.program_conversion_bps, 1) + ' program average.'
          : ' — the program average is ' + bpsPct(bench.program_conversion_bps, 1) + '.';
      } else { funNote += '.'; }
    } else if (mt.orders > 0) {
      funNote = 'These sales came in through your <b>code</b>. Share your link too and we’ll track clicks and your conversion rate.';
    } else { funNote = 'Share your link to start the funnel.'; }
    var fun = el('div', 'lkc__tile');
    fun.appendChild(el('div', 'lkc__tileh', 'Clicks → orders'));
    var frow = el('div', 'lkc__fun');
    frow.appendChild(funStep(num(mt.clicks), 'Clicks'));
    frow.appendChild(el('i', 'lkc__funar', '&rsaquo;'));
    frow.appendChild(funStep(num(mt.orders), 'Orders'));
    frow.appendChild(el('i', 'lkc__funar', '&rsaquo;'));
    frow.appendChild(funStep(money0(mt.lifetime_earned_cents), 'Earned', true));
    fun.appendChild(frow);
    fun.appendChild(el('div', 'lkc__rate', funNote));
    two.appendChild(fun);
    // attribution
    var sp = d.source_split || { code_cents: 0, link_cents: 0 };
    var tot = (sp.code_cents || 0) + (sp.link_cents || 0);
    var att = el('div', 'lkc__tile');
    att.appendChild(el('div', 'lkc__tileh', 'How your sales are attributed'));
    if (tot > 0) {
      var codePct = Math.round((sp.code_cents / tot) * 100), linkPct = 100 - codePct;
      att.appendChild(el('div', 'lkc__splitbar', '<div class="lkc__sp-code" style="width:' + codePct + '%"></div><div class="lkc__sp-link" style="width:' + linkPct + '%"></div>'));
      att.appendChild(el('div', 'lkc__leg', '<span><i class="lkc__k lkc__k-code"></i>Code · ' + codePct + '%</span><span><i class="lkc__k lkc__k-link"></i>Link · ' + linkPct + '%</span>'));
      att.appendChild(el('div', 'lkc__tnote', codePct >= linkPct ? 'Most buyers type your code at checkout — cookie-proof, so nothing slips through.' : 'Most sales come through your link. Sharing your code too can lift the total.'));
    } else {
      att.appendChild(el('p', 'lkc__empty', 'Once sales land, you\'ll see how many came from your code vs your link.'));
    }
    two.appendChild(att);
    wrap.appendChild(two);

    /* per-partner breakdown */
    var vendors = (d.vendors || []).filter(function (v) { return v.commission_cents > 0; });
    if (vendors.length) {
      wrap.appendChild(sect('By partner'));
      var vmax = vendors[0].commission_cents || 1;
      var vlist = el('div', 'lkc__vend'); vlist.setAttribute('data-rev', '1');
      vendors.forEach(function (v) {
        var w = Math.max(6, Math.round((v.commission_cents / vmax) * 100));
        var row = el('div', 'lkc__vrow');
        row.appendChild(el('span', 'lkc__vname', esc(v.vendor)));
        row.appendChild(el('span', 'lkc__vbar', '<i style="width:' + w + '%"></i>'));
        row.appendChild(el('span', 'lkc__vamt', money(v.commission_cents)));
        vlist.appendChild(row);
      });
      wrap.appendChild(vlist);
    }

    /* share */
    wrap.appendChild(sect('Share & earn'));
    var share = el('div', 'lkc__share'); share.setAttribute('data-rev', '1');
    share.appendChild(el('span', 'lkc__url', esc(refLink)));
    var sb = copyBtn(refLink, 'lkc__btn', 'Copy link'); sb.innerHTML = '<i class="lkc__i-copy"></i> Copy link';
    share.appendChild(sb);
    wrap.appendChild(share);
    if (p.discount_bps) wrap.appendChild(rev(el('p', 'lkc__tnote lkc__tnote--wide', 'Your audience saves <b>' + bpsPct(p.discount_bps, 1) + '</b> with your code. You earn <b>' + bpsPct(p.rate_bps, 1) + '</b> of the net on every order you drive.')));
    if (p.code_ready === false) wrap.appendChild(rev(el('p', 'lkc__tnote lkc__tnote--wide', '<b>Heads up:</b> your discount code is still being set up — it will start working at checkout shortly.')));

    /* recent feed */
    wrap.appendChild(sect('Recent sales'));
    var convs = d.conversions || [];
    if (!convs.length) {
      wrap.appendChild(rev(el('p', 'lkc__empty', 'No sales attributed yet. Share your link and they\'ll appear here.')));
    } else {
      var feed = el('div', 'lkc__feed'); feed.setAttribute('data-rev', '1');
      convs.forEach(function (c) {
        var row = el('div', 'lkc__row');
        row.appendChild(el('span', 'lkc__tick lkc__tick--' + esc(c.bucket)));
        var meta = c.matures_on ? ('Matures ' + dateShort(c.matures_on)) : (c.reason ? esc(c.reason) : dateShort(c.created_at));
        var mid = el('div', null, '<div class="lkc__ord">' + esc(c.order_name || '—') + '</div><div class="lkc__meta">' + meta + '</div>');
        row.appendChild(mid);
        var right = el('div', 'lkc__right');
        var amt = c.bucket === 'reversed' ? money(0) : ('+' + money(c.commission_cents));
        right.appendChild(el('div', 'lkc__amt', amt + '<small>' + money(c.net_cents) + ' net</small>'));
        right.appendChild(el('div', 'lkc__st lkc__st--' + esc(c.bucket), esc(BUCKET[c.bucket] || c.bucket)));
        row.appendChild(right);
        feed.appendChild(row);
      });
      wrap.appendChild(feed);
    }

    /* payout history */
    var payouts = d.payouts || [];
    if (payouts.length) {
      wrap.appendChild(sect('Payout history'));
      var pl = el('div', null); pl.setAttribute('data-rev', '1');
      payouts.forEach(function (po) {
        pl.appendChild(el('div', 'lkc__pay', '<b>' + money(po.amount_cents) + '</b><span>' + esc(po.method === 'credit' ? 'store credit' : 'cash') + ' · ' + dateShort(po.created_at) + (po.conversion_count ? (' · ' + po.conversion_count + ' orders') : '') + '</span>'));
      });
      wrap.appendChild(pl);
    }

    /* FAQ */
    wrap.appendChild(sect('Creator FAQ'));
    var faqWrap = el('div', 'lkc__faq'); faqWrap.setAttribute('data-rev', '1');
    faqItems(hold, p, min).forEach(function (qa, i) {
      var d2 = el('div', 'lkc__qa' + (i === 0 ? ' open' : ''));
      var btn = el('button', 'lkc__q', esc(qa.q) + '<span class="lkc__mk">+</span>'); btn.type = 'button';
      var ans = el('div', 'lkc__a', qa.a);
      d2.appendChild(btn); d2.appendChild(ans);
      faqWrap.appendChild(d2);
    });
    wrap.appendChild(faqWrap);

    wireInteractions(wrap);
  }

  /* ---- component builders ---- */
  function rev(node) { node.setAttribute('data-rev', '1'); return node; }
  function fig(value, label, extra) {
    var f = el('div', 'lkc__fig');
    f.appendChild(el('b', 'dsp', esc(value) + (extra ? extra : '')));
    f.appendChild(el('span', null, esc(label)));
    return f;
  }
  function deltaChip(cur, prev) {
    if (prev > 0) { var d = Math.round(((cur - prev) / prev) * 100); if (d === 0) return ''; return '<i class="lkc__delta ' + (d > 0 ? 'up' : 'down') + '">' + (d > 0 ? '▲' : '▼') + Math.abs(d) + '%</i>'; }
    if (cur > 0) return '<i class="lkc__delta up">new</i>';
    return '';
  }
  function cell(value, label, hint, tone) {
    var c = el('div', 'lkc__cell');
    c.appendChild(el('div', 'lkc__n dsp' + (tone === 'warn' ? ' lkc__n--warn' : ''), esc(value)));
    c.appendChild(el('div', 'lkc__l', esc(label)));
    if (hint) c.appendChild(el('div', 'lkc__hint', esc(hint)));
    return c;
  }
  function funStep(value, label, hot) {
    var s = el('div', 'lkc__funs');
    s.appendChild(el('div', 'lkc__funn dsp' + (hot ? ' lkc__funn--hot' : ''), esc(value)));
    s.appendChild(el('div', 'lkc__funl', esc(label)));
    return s;
  }
  function sect(title, tail) {
    var s = el('div', 'lkc__sect'); s.setAttribute('data-rev', '1');
    s.appendChild(document.createTextNode(title));
    if (tail) s.appendChild(el('span', null, '· ' + tail));
    return s;
  }
  function copyBtn(value, cls, label) {
    var b = el('button', cls, cls === 'lkc__mini' ? '<i class="lkc__i-copy"></i>' : 'Copy');
    b.type = 'button'; b.setAttribute('data-copy', value); b.setAttribute('aria-label', label);
    return b;
  }

  function wireInteractions(wrap) {
    wrap.addEventListener('click', function (e) {
      var t = e.target;
      var q = t.closest ? t.closest('.lkc__q') : null;
      if (q) { var qa = q.parentNode, a = qa.querySelector('.lkc__a'); if (qa.classList.contains('open')) { a.style.maxHeight = 0; qa.classList.remove('open'); } else { qa.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; } return; }
      var cp = t.closest ? t.closest('[data-copy]') : null;
      if (cp) {
        var v = cp.getAttribute('data-copy');
        try { navigator.clipboard.writeText(v); } catch (err) {}
        if (cp.classList.contains('lkc__btn')) { var h = cp.innerHTML; cp.innerHTML = '<i class="lkc__i-check"></i> Copied'; setTimeout(function () { cp.innerHTML = h; }, 1400); }
        else { cp.classList.add('is-ok'); setTimeout(function () { cp.classList.remove('is-ok'); }, 1200); }
      }
    });
  }

  function faqItems(hold, p, min) {
    var minS = min ? money0(min) : 'the minimum';
    var payout = p.payout_method === 'credit' ? 'store credit' : 'cash';
    var rate = bpsPct(p.rate_bps, 1);
    return [
      { q: 'How do I earn commission?', a: '<p>Share your link or code. When someone buys — gear, a booking, a pass or a gift card — the sale is attributed to you, and you earn ' + rate + ' on the <strong>net</strong> subtotal (after any discount, excluding shipping, tax and gift cards).</p>' },
      { q: 'What counts as my sale?', a: '<p>An order that carries <strong>your code</strong>, or one where the buyer arrived through <strong>your link</strong> and used no other creator’s code. Your code is server-side, so it works even if a browser drops the tracking cookie.</p>' },
      { q: 'When do I get paid?', a: '<p>Commissions are held <strong>' + hold + ' days</strong> (our refund window plus a buffer), then become <strong>Payable</strong>. Once your Payable clears ' + minS + ', we pay you as <strong>' + payout + '</strong>.</p>' },
      { q: 'What do Booked, Payable and Paid mean?', a: '<p><strong>Booked</strong> — earned, still in the hold window (it matures on the date shown). <strong>Payable</strong> — matured and ready. <strong>Paid</strong> — already sent to you.</p>' },
      { q: 'What happens if a customer refunds?', a: '<p>If an attributed order is refunded or cancelled during the hold, the commission is <strong>Reversed</strong> (fully, or proportionally for a partial refund). A commission already paid out is not clawed back automatically — we’ll reach out if that happens.</p>' },
      { q: 'What isn’t allowed?', a: '<p>Buying with your own code, posting it to coupon or deal sites, bidding on “ATHLO” brand keywords, or any fake traffic. These forfeit affected commissions and can end your participation.</p>' },
      { q: 'A number looks wrong — what do I do?', a: '<p>Everything here reads from the same data our team sees, so it can’t quietly disagree. If something still looks off, contact us and we’ll walk through it with you.</p>' }
    ];
  }
})();
